import { NormalizedNumber } from '@sparkdotfi/common-universal'
import BigNumber from 'bignumber.js'

import { CollateralAlert } from '../components/CollateralAlert'
import { CollateralOverviewPanel } from '../components/CollateralOverviewPanel'
import { CollateralSetting } from '../types'
import { Token } from '@/domain/types/Token'
import { ActionsViewState } from '@/features/actions/types'
import { ActionsView } from '@/features/actions/views/ActionsView'
import { MultiPanelDialog } from '@/features/dialogs/common/components/MultiPanelDialog'
import { RiskAcknowledgementInfo } from '@/features/sparklend/common/utils/liquidation-risk-warning/types'
import { SetUseAsCollateralValidationIssue } from '@/features/sparklend/common/validation/validateSetUseAsCollateral'
import { DialogTitle } from '@/ui/atoms/dialog/Dialog'
import { RiskAcknowledgement } from '@/ui/organisms/risk-acknowledgement/RiskAcknowledgement'

interface CollateralViewProps {
  collateralSetting: CollateralSetting
  collateral: Token
  collateralBalance: NormalizedNumber
  validationIssue: SetUseAsCollateralValidationIssue | undefined
  currentHealthFactor?: BigNumber
  updatedHealthFactor?: BigNumber
  riskAcknowledgement: RiskAcknowledgementInfo
  actionsViewState: ActionsViewState
}

export function CollateralView({
  collateralSetting,
  collateral,
  collateralBalance,
  validationIssue,
  currentHealthFactor,
  updatedHealthFactor,
  riskAcknowledgement,
  actionsViewState,
}: CollateralViewProps) {
  return (
    <MultiPanelDialog>
      <DialogTitle>Collateral</DialogTitle>

      <CollateralAlert collateralSetting={collateralSetting} issue={validationIssue} />

      <CollateralOverviewPanel
        collateral={collateral}
        collateralBalance={collateralBalance}
        currentHealthFactor={currentHealthFactor}
        updatedHealthFactor={updatedHealthFactor}
      />

      {riskAcknowledgement.warning && (
        <RiskAcknowledgement
          onStatusChange={riskAcknowledgement.onStatusChange}
          warning={riskAcknowledgement.warning}
        />
      )}

      <ActionsView state={actionsViewState} actionsGridLayout="compact" allowChangeWhenActionsInProgress={false} />
    </MultiPanelDialog>
  )
}
